<template>
  <div v-if="userExtraInformation">
    <section class="main">
      <div class="centering_with_gap flex">
        <div class="partial_land">
          <div class="centering_with_gap">
            <div class="flex rem-margin-bottom">
              <div class="main_profile_title">
              
                <div class="profile-image">
                  <img :src="userExtraInformation.profile_image" alt="" class="profile-pic">
                </div>
                <div class="">
                  <h2>{{userExtraInformation.name}}</h2>
                  <span class="title">{{userExtraInformation.title}}</span>
                </div>
              </div>
              <div class="main_profile_icons">
                <!-- existing buttons -->
                <a v-if="userExtraInformation.facebook_link" 
                  :href="userExtraInformation.facebook_link"
                  class="profile_social_icon"
                  target="_blank">
                    <img
                      src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/icons%2FFacebook_Logo_Primary.png?alt=media&token=2731adce-75a0-493d-ac5d-94a2913b2aa4"
                      alt="Facebook"
                      height="35px"
                      width="35px"
                    >
                </a> <!-- Facebook Link -->
                <a v-if="userExtraInformation.instagram_link"
                   :href="userExtraInformation.instagram_link"
                   class="profile_social_icon"
                   target="_blank">
                    <img
                      src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/icons%2FInstagram_Glyph_Gradient.png?alt=media&token=67820264-b94c-48d9-b2fc-e1a6acda27d2"
                      alt="Instagram"
                      height="35px"
                      width="35px"
                    >
                </a>  <!-- Instagram Link -->
                <a v-if="userExtraInformation.website_link"
                   :href="userExtraInformation.website_link"
                   class="profile_social_icon"
                   target="_blank">
                    <img
                      src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/icons%2FURLIcon.png?alt=media&token=010bba69-2e1c-4284-9f13-e6c5e8612cc8"
                      alt="Website"
                      height="35px"
                      width="35px"
                    >
                </a> <!-- Website Link -->
              </div>
            </div>
            <div class="user-profile-text">
              <p>{{userExtraInformation.about}}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>


<script>

import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'PresentUserInfo',

  computed: mapGetters('presentUserInfo', [
    "userExtraInformation",
  ]),
  methods: {
    ...mapActions('presentUserInfo', ["fetchUserExtarInformationForRide",
                  ]),
  },
    // We moved this one to the creation of the full page to improve SEO
    // created() {
    //   this.fetchUserExtarInformationForRide();
    // },
  };


</script>